export const summaryRows: string[] = [
  'Volume 01 — Fire Protection Fundamentals: Fire Science, Hazards & Protection Strategy',
  'Volume 02 — Fire Detection & Alarm Systems: Detectors, Panels, Notification & Interfaces',
  'Volume 03 — Fire Sprinkler Systems: Wet, Dry, Pre-Action & Deluge',
  'Volume 04 — Fire Water Supply, Fire Pumps, Hydrants & Standpipes',
  'Volume 05 — Special Hazard Suppression: Foam, Clean Agents, CO2, Water Mist & Dry Chemical',
  'Volume 06 — Inspection, Testing, Maintenance & Industrial Fire Protection Operations',
  'Bonus 1 — Fire Protection Formulas & Calculations Quick-Reference',
  'Bonus 2 — Fire Protection Inspection & Testing Checklists',
  'Bonus 3 — Fire Extinguisher Selection & Use Field Guide',
  'Bonus 4 — How to Read Fire Protection Drawings, Riser Diagrams & Cause-and-Effect Matrices',
  'Bonus 5 — Fire Protection Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
